import LanguageListItem from './LanguageListItem';
import LanguageEntity from './LanguageEntity';
import ProfileList from '../common/ProfileList';
import { useContext } from 'react';
import { FreelancerContext } from '../FreelancerEntity';
import { TEXTS } from '../../../../core/texts';

const LANGUAGE_QUERY_PARAM = 'language';

const LanguagesList = () => {
  const { user } = useContext(FreelancerContext);
  return (
    <ProfileList
      list={user.freelancerProfile.languages || []}
      title={TEXTS.LANGUAGES}
      emptyListText={'Not added'}
      ListItemComponent={LanguageListItem}
      EntityComponent={LanguageEntity}
      entityQueryParam={LANGUAGE_QUERY_PARAM}
    />
  );
};

export default LanguagesList;